import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';

export const Button = styled(BaseButton)(() => ({}));

export const ActionsFooter = styled('div')(({ theme, disableBorder }) => ({
  alignItems: 'center',
  borderTop: disableBorder ? 'none' : `1px solid ${theme.color.grey[500]}`,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'flex-end',
  margin: `0 ${theme.spacing(3)}`,
  padding: `${theme.spacing(3)} 0`,
  '@media (max-width: 768px)': {
    justifyContent: 'center'
  },
  '@media (max-width: 400px)': {
    [`& ${Button}`]: {
      flexGrow: 1
    }
  }
}));
